import { IconInfo, IconWarning } from "@origin-digital/ods-icons";
import React from "react";
import styled from "styled-components";
import { AlertBanner, Text } from "@origin-digital/ods-core";

const RightDiv = styled.div`
  font-family: "origin-gordita", "gordita", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.7em;
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const TitleDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const NotificationHeader = styled.h4`
  text-transform: none;
  margin: 0;
  font-weight: 600;
  padding-right: 4px;
`;

const Paragraph = styled.span`
  margin: 0;
`;

export interface IBannerView {
  index: number;
  bannerId?: number;
  type?: "warning" | "info";
  heading: string;
  message: string;
  onCloseButtonClick: () => void;
}

export const BannerView: React.FC<IBannerView> = ({
  index,
  bannerId,
  type,
  heading,
  message,
  onCloseButtonClick,
}) => {
  const isFirstBanner = index === 0;
  const icon =
    type === "warning" ? (
      <IconWarning variant="solid" />
    ) : (
      <IconInfo variant="solid" />
    );
  return (
    <AlertBanner
      tone={type === "warning" ? "caution" : "info"}
      onCloseClick={isFirstBanner ? onCloseButtonClick : undefined}
      data-id={`crisis-banner-${bannerId?.toString()}`}
      fluidity={true}
      icon={icon}
    >
      <RightDiv>
        <TitleDiv>
          <Text>
            <NotificationHeader dangerouslySetInnerHTML={{ __html: heading }} />
          </Text>
        </TitleDiv>
        <Text>
          <Paragraph dangerouslySetInnerHTML={{ __html: message }} />
        </Text>
      </RightDiv>
    </AlertBanner>
  );
};
